// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useState} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../../../shared/button';
import {get_img_url} from './utils';
import {build_support_link} from '../support_report';
import styles from './bounty_hero.module.less';

export interface i_bounty_hero_props {
  title?: string;
  description?: string;
  image_src?: string;
  image_alt?: string;
  cta_text?: string;
}

export const Bounty_hero = ({
  title,
  description,
  image_src,
  image_alt,
  cta_text,
}: i_bounty_hero_props)=>{
  return <section className={styles.bounty_hero}>
    <div className={styles.bounty_hero__inner}>
      <div className={styles.bounty_hero__content}>
        {title&&<h2 className={styles.bounty_hero__title}>
          {title}
        </h2>}
        {description&&<p className={styles.bounty_hero__description}>
          {description}
        </p>}
        {cta_text&&<Button
          caption={cta_text}
          to={build_support_link()}
          cls={styles.bounty_hero__cta}
          round
        />}
      </div>
      {image_src&&<div className={styles.bounty_hero__visual}>
        <img
          className={styles.bounty_hero__image}
          src={get_img_url(image_src)}
          alt={image_alt||''}
          aria-hidden={!image_alt}
        />
      </div>}
    </div>
  </section>;
};


interface i_bounty_hero_editor_props {
  value: i_bounty_hero_props;
  on_change: (value: i_bounty_hero_props)=>void;
  on_cancel?: ()=>void;
}

export const Bounty_hero_editor = (
  props: i_bounty_hero_editor_props
)=>{
  const [state, set_state] = useState<i_bounty_hero_props>(
    props.value||{}
  );
  return <Editor<i_bounty_hero_props>
    value={state}
    editors={[
      {key: 'title', label: 'Title', type: 'text'},
      {key: 'description', label: 'Description', type: 'textarea'},
      {key: 'image_src', label: 'Image', type: 'text'},
      {key: 'image_alt', label: 'Image alt', type: 'text'},
      {key: 'cta_text', label: 'CTA text', type: 'text'},
    ]}
    on_change={set_state}
    on_save={()=>props.on_change(state)}
    on_cancel={props.on_cancel}
  />;
};
